import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import PhotoContainer from '../PhotoContainer';
import actions from '../../redux/actions';

class NewTeam extends Component {
  handleCreate(e) {
    e.preventDefault();

    this.props.selectTeam();
    this.props.setMembers();

    if (this.props.type === 'create') {
      this.props.router.push('/create/create-team');
    } else if (this.props.type === 'create-deal') {
      this.props.router.push('/create-deal/create-team');
    } else {
      this.props.router.push('/teams/create');
    }
  }

  render() {
    const { type } = this.props;

    if (type === 'view') {
      return (
        <Row>
          <Col md={12}>
            <div className="text-center button-list">
              <a
                type="button"
                className="btn btn-link btn-register-new"
                onClick={(e) => this.handleCreate(e)}
              >
                Create New Team
              </a>
            </div>
          </Col>
        </Row>
      );
    } else {
      return (
        <div className="team new-team">
          <div className="top">
            <div className="team-photo">
              <PhotoContainer className="photo-container">
                <a onClick={(e) => this.handleCreate(e)}>
                  <FontAwesome name="plus" />
                </a>
              </PhotoContainer>
            </div>
            <div className="team-title">New Team</div>
          </div>
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectTeam: () => {
    dispatch(actions.selectTeam(null));
  },
  setMembers: () => {
    dispatch(actions.setTeamMembers([]));
  },
});

export default connect(null, mapDispatchToProps)(withRouter(NewTeam));



// WEBPACK FOOTER //
// src/components/Teams/NewTeam.jsx